import API from './api'
import { Urls } from './urls'
import snackbarMessages from "./snackbarMessages"
import GLOBALS from "./GLOBALS";
import {handleError} from "./handleError";
import { useDispatch } from "react-redux";
import { resetRouteState } from "../redux/store/routeSlice";

export const InstitutionService = {

  list_own: function (dispatch) { 

    // Clear sessionStorage
    sessionStorage.removeItem("evaluator_status");
    sessionStorage.removeItem("user_roles");
    
    // Reset Redux store
    dispatch(resetRouteState());
    
    // Every time we get the list of institutions, user permissions are clear
    sessionStorage.removeItem(GLOBALS.SESSION_KEYS.PERMISSIONS);
    sessionStorage.removeItem(GLOBALS.SESSION_KEYS.IS_OWNER);
    sessionStorage.removeItem(GLOBALS.SESSION_KEYS.EVALUATOR_STATUS);
    sessionStorage.removeItem(GLOBALS.SESSION_KEYS.USER_ROLES);
    return API.get(Urls.ApiListOwnInstitutions)
      .then((response) => {
          return response;
      })
      .catch((error) => {
          handleError(error, snackbarMessages.error.institutions.get);
      });
},
  getInstitutions: function () {
    return API.get(Urls.ApiInstitution).then((response) => {
      return response
    })
      .catch((error) => {
        handleError(error, snackbarMessages.error.institutions.get);
      })
  },

  //Depends on model get Patients for Institution or Reports for subject
  getObjects: function (id, model) {
    const permissions = JSON.parse(sessionStorage.getItem(GLOBALS.SESSION_KEYS.PERMISSIONS));
    let list_endpoint;
    if (model === 'Patients'){
      if (permissions['subjects']?.find((perm)=>(perm===GLOBALS.PERMISSIONS.LIST_INST))){
        list_endpoint = GLOBALS.ENDPOINTS.SUBJECT.LIST_INST + '/';
      }
      else list_endpoint = GLOBALS.ENDPOINTS.SUBJECT.LIST_INST_USER + '/';
    }
    return API.post(list_endpoint + id)
      .then((response) => {
        const data = response?.data?.data['evaluation_list'] ? response.data.data['evaluation_list']
                    : response?.data['data'];
        return data || []
    })
        .catch((error) => {
          handleError(error, snackbarMessages.error.objects.get);
        })
  }
};

